import { render, staticRenderFns } from "./columnConfigurations.vue?vue&type=template&id=d3a55ecc&scoped=true&"
import script from "./columnConfigurations.vue?vue&type=script&lang=js&"
export * from "./columnConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./columnConfigurations.vue?vue&type=style&index=0&id=d3a55ecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a55ecc",
  null
  
)

export default component.exports